module.exports = __webpack_public_path__ + "img/sys-icon-1.c7fc430.png";